(function () {
  function updateMuteButton(slide, video) {
    var muteBtn = slide.querySelector('[data-media-mute]');
    if (!muteBtn) return;
    if (!video) {
      muteBtn.hidden = true;
      return;
    }

    muteBtn.hidden = false;
    var unmuted = !video.muted;
    muteBtn.classList.toggle('is-unmuted', unmuted);
    muteBtn.setAttribute('aria-label', unmuted ? 'Couper le son' : 'Activer le son');
  }

  function stopOtherVideos(slides, current) {
    slides.forEach(function (slide) {
      var video = slide.querySelector('video');
      if (!video || slide === current) return;
      video.pause();
      video.currentTime = 0;
      video.muted = true;
      var muteBtn = slide.querySelector('[data-media-mute]');
      if (muteBtn) muteBtn.hidden = true;
    });
  }

  function setActiveSlide(slides, slide, playVideo) {
    if (!slide) return;

    slides.forEach(function (candidate) {
      candidate.classList.toggle('is-active', candidate === slide);
      var buyBtn = candidate.querySelector('[data-media-buy]');
      if (buyBtn) buyBtn.hidden = candidate !== slide;
      var muteBtn = candidate.querySelector('[data-media-mute]');
      if (muteBtn && candidate !== slide) muteBtn.hidden = true;
    });

    stopOtherVideos(slides, slide);
    var video = slide.querySelector('video');
    var muteBtn = slide.querySelector('[data-media-mute]');
    if (muteBtn) muteBtn.hidden = true;

    if (!video) return;
    if (playVideo) {
      video.play().then(function () {
        updateMuteButton(slide, video);
      }).catch(function () {});
    } else {
      video.pause();
    }
  }

  function init(root) {
    var slider = root.querySelector('.cleogene-media-slider');
    var track = root.querySelector('[data-media-slider-track]');
    if (!slider || !track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.cleogene-media-slider__slide'));
    if (!slides.length) return;

    var mediaCount = slides.length;
    slider.style.setProperty('--media-count', String(mediaCount));
    var desktopMq = window.matchMedia('(min-width: 990px)');

    function applyStaticMode() {
      slider.classList.toggle('is-static', mediaCount <= 4 && desktopMq.matches);
    }

    applyStaticMode();

    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', applyStaticMode);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(applyStaticMode);
    }

    track.addEventListener('click', function (event) {
      var muteBtn = event.target.closest('[data-media-mute]');
      if (muteBtn) {
        event.preventDefault();
        event.stopPropagation();
        var muteSlide = muteBtn.closest('.cleogene-media-slider__slide');
        if (!muteSlide) return;
        var muteVideo = muteSlide.querySelector('video');
        if (!muteVideo) return;
        muteVideo.muted = !muteVideo.muted;
        updateMuteButton(muteSlide, muteVideo);
        return;
      }

      var trigger = event.target.closest('[data-media-activate]');
      if (!trigger) return;
      var slide = trigger.closest('.cleogene-media-slider__slide');
      if (!slide) return;
      setActiveSlide(slides, slide, true);
    });

    setActiveSlide(slides, slides[0], true);
  }

  document.querySelectorAll('[data-media-slider-root]').forEach(init);
})();
